/**
 * Copyright 2013-2017 Zegeba AS (814 777 812 MVA), Ålesund, Norway
 *                     www.zegeba.com - contact@zegeba.com
 *
 * All rights reserved. You may not use or distribute the content of this file
 * in part or as a whole without explicit written consent from Zegeba AS.
 *
 * This software/the content of this file is distributed AS IS, WITHOUT WARRANTIES OF ANY KIND.
 * Zegeba AS or the authors of the software accepts NO LEGAL LIABILITY OR RESPONSIBILITY for any
 * loss due to the use of the software/content of this file.
 *
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import superagent from "superagent";
import App from "./App";
import router from "./router";
import store from "./store";
import vuetify from "@/plugins/vuetify";
import "vuetify/dist/vuetify.min.css";

import TopNavbar from "./components/layout/TopNavbar";

Vue.use(superagent);

Vue.config.productionTip = false;

Vue.component("top-navbar", TopNavbar);

new Vue({
	store,
	el: "#app",
	router,
	components: { App },
	template: "<App/>",
	vuetify
});



// WEBPACK FOOTER //
// ./src/main.js